import { AdminLoginPage } from '~/pages/AdminLoginPage';
import './App.css';

function App() {
  return (
    <div id="app">
      <AdminLoginPage />
    </div>
  );
}

export default App;
